import { render, staticRenderFns } from "./CouponPop.vue?vue&type=template&id=fef14dee&scoped=true"
import script from "./CouponPop.vue?vue&type=script&lang=js"
export * from "./CouponPop.vue?vue&type=script&lang=js"
import style0 from "./CouponPop.vue?vue&type=style&index=0&id=fef14dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef14dee",
  null
  
)

export default component.exports